module.exports = __webpack_public_path__ + "img/icon-gas-oven.a2772c9f.svg";